export default "__VITE_ASSET__CqPb3D55__"